import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31717dc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "home__content" }

import { computed, onMounted, ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import { delay } from '@/utils/async'
import { now } from '@/utils/time'
import { blogData } from '@/assets/data/blog'

import Hero from '@/components/Hero.vue'
import MediaLinkPreview from '@/components/MediaLinkPreview.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isShowing = ref<boolean>(false)

const featuredPost = computed(() => blogData.filter(bd => new Date(bd.date).getTime() < now.getTime())[0])

const featuredVideos = [
  {
    title: 'Golf Trip Vlog',
    youtubeId: 'vrRxh62yJkE'
  },
  {
    title: 'Course Review',
    youtubeId: 'QPouPCHec-c'
  },
  {
    title: 'Golf Tips',
    youtubeId: 'GfLaTTuh8yM'
  },
  {
    title: 'Course Review',
    youtubeId: 'MWat3BWoL5c'
  },
]

onBeforeRouteLeave(async () => {
  isShowing.value = false
  await delay(800)
})

onMounted(async () => {
  document.title = 'ForeChamp | Home'
  await delay(200)
  isShowing.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home page-container transition__page", { 'isShowing': isShowing.value }])
  }, [
    _createVNode(Hero, {
      headline: "Here to help you enjoy golf",
      imageSrc: "fall-golf-hero.jpg",
      imageAlt: "Homepage hero image"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MediaLinkPreview, {
          cta: "Click To Read",
          id: _unref(featuredPost).date,
          image: _unref(featuredPost).image,
          media: "blog",
          size: "short",
          title: _unref(featuredPost).title
        }, null, 8, ["id", "image", "title"]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(featuredVideos, (fv, fvIndex) => {
          return _createVNode(MediaLinkPreview, {
            key: fvIndex,
            cta: "Click To Watch",
            "hide-title": "",
            id: fv.youtubeId,
            size: "half",
            title: fv.title
          }, null, 8, ["id", "title"])
        }), 64)),
        _createVNode(MediaLinkPreview, {
          cta: "Click To Listen",
          "hide-title": "",
          image: "podcast-hero.jpg",
          media: "podcast",
          size: "short",
          title: "The Downswing - Golf Podcast"
        })
      ])
    ])
  ], 2))
}
}

})